import React, { Suspense, useState } from "react"
import { Auth } from "./middlewares/Auth"
import { Cookies } from "react-cookie"
import { DecryptToken } from "./middlewares/DecryptToken"
import { HashRouter, Route, Routes } from "react-router-dom"
import { CAlert, CCard, CCardBody, CCol, CContainer, CRow } from "@coreui/react"
import { EmojiSmileUpsideDown, ExclamationTriangle, PatchCheckFill } from "react-bootstrap-icons"
import "./scss/style.scss"

const App = () => {
  const DefaultLayout = React.lazy(() => import("./components/DefaultLayout.js"))
  const cookies = new Cookies(), auth = new Auth(), dt = new DecryptToken(), [flash, setFlash] = useState("")
  const searchParams = new URLSearchParams(window.location.search), source = searchParams.get("source")
  const notAuthorized = "Your Google account is not authorized on this platform, please contact Revota Support for authorize."
  const serverProblem = "There is a problem on the server, please inform this to Revota Support."
  const serverUpdate = "There is an update on the Revota server, please re-login."
  const googleLogin = () => { window.open(`${process.env.REACT_APP_SSO_URL}auth/google`, "_self") }

  if (!cookies.get(process.env.REACT_APP_COOKIE_NAME) && source === "google") {
    auth.googleSSO().then(res => {
      if (res.headers.get("content-type").includes("application/json")) {
        const photo = res?.data?.photos[0]?.value
        auth.verify(res?.data?.emails[0]?.value).then(response => {
          if (!response.statusCode) {
            if (response.token && response.token !== null) {
              response.photo = photo
              dt.encrypt(response).then(encrypted => {
                cookies.set(process.env.REACT_APP_COOKIE_NAME, encrypted.data, { maxAge: 60000 })
                window.location.assign(process.env.REACT_APP_BASE_URL)
              }).catch(() => setFlash(serverProblem))
            } else { setFlash(notAuthorized) }
          } else { setFlash(serverProblem) }
        }).catch(() => setFlash(serverProblem))
      } else { setFlash(serverProblem) }
    }).catch(() => setFlash(serverProblem))

    return (
      <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
        <CContainer className="pt-5">
          <CRow className="justify-content-center">
            <CCol md={9} lg={7} xl={5} className="text-center"><PatchCheckFill size={60} color="black" /></CCol>
          </CRow>
          <CRow className="justify-content-center">
            <CCol md={9} lg={7} xl={5}>
              <CCard className="p-4 pt-0 border-0">
                <CCardBody className="text-center">
                  <h1 className="mb-4">Revota Popi Autumn</h1>
                  {flash !== "" ?
                    <>
                      <CAlert dismissible color="danger" variant="solid" className="fs-4 mb-4 alert-login-custom">
                        <ExclamationTriangle size={25} /><br />{flash}
                      </CAlert>
                      <a className="btn btn-lg fw-bold text-muted custom-link google-button" onClick={googleLogin}>
                        <img src={`${process.env.REACT_APP_BASE_URL}google_logo.png`} className="me-2" />Sign in with Google
                      </a>
                    </> : <div className="d-flex justify-content-center pt-2"><div className="spinner-border"></div></div>
                  }
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
          <CRow className="justify-content-center text-center text-muted">
            <span>
              &copy; {new Date().getFullYear()}
              <a href="https://revota.id" target="_blank" className="text-muted ms-1">Revota.</a> All rights reserved.
            </span>
          </CRow>
        </CContainer>
      </div>
    )
  } else if (!cookies.get(process.env.REACT_APP_COOKIE_NAME) && source !== "google") {
    return (
      <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
        <CContainer className="pt-5">
          <CRow className="justify-content-center">
            <CCol md={9} lg={7} xl={5} className="text-center"><PatchCheckFill size={60} color="black" /></CCol>
          </CRow>
          <CRow className="justify-content-center">
            <CCol md={9} lg={7} xl={5}>
              <CCard className="p-4 pt-0 border-0">
                <CCardBody className="text-center">
                  <h1 className="mb-4">Revota Popi Autumn</h1>
                  {source === "server-update" ?
                    <CAlert dismissible color="info" variant="solid" className="fs-4 mb-4 alert-login-custom">
                      <EmojiSmileUpsideDown size={25} /><br />{serverUpdate}
                    </CAlert> : ""
                  }
                  <a className="btn btn-lg fw-bold text-muted custom-link google-button" onClick={googleLogin}>
                    <img src={`${process.env.REACT_APP_BASE_URL}google_logo.png`} className="me-2" />Sign in with Google
                  </a>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
          <CRow className="justify-content-center text-center text-muted">
            <span>
              &copy; {new Date().getFullYear()}
              <a href="https://revota.id" target="_blank" className="text-muted ms-1">Revota.</a> All rights reserved.
            </span>
          </CRow>
        </CContainer>
      </div>
    )
  } else {
    return (
      <HashRouter>
        <Suspense><Routes><Route path="*" name="default-layout" element={<DefaultLayout />} /></Routes></Suspense>
      </HashRouter>
    )
  }
}

export default App